// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__3oljA"};